import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]
  static values = { nextIndex: Number }

  connect() {
    if (!this.hasNextIndexValue) {
      this.nextIndexValue = this.listTarget.children.length
    }
  }

  add() {
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, this.nextIndexValue)
    this.nextIndexValue += 1
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-entry-row]")
    if (row) {
      row.remove()
    }
  }
}
